import DIApi from './_diApi';

class AccountCategoryAPI extends DIApi {
  constructor() {
    super();
  }
  controllerName = 'AccountCategorys';
}

export default new AccountCategoryAPI();
